import React from 'react'
import { Pagination, Row, Col, Form } from '@themesberg/react-bootstrap'

const PaginationComponent = ({ page, totalPages, setPage, limit, setLimit, dontShowRow = false, paginationRef, totalCount, showTotalCount = false, countText = "" }) => {
  const OPTIONS_ARR = [15, 20, 50, 100]
  const items = []

  if (totalPages > 5) {
    const showFirstPages = page < 3
    const showLastPages = page > totalPages - 2

    if (!showFirstPages) {
      items.push(
        <Pagination.Item key={1} active={page === 1} onClick={() => setPage(1)}>
          {1}
        </Pagination.Item>
      )

      items.push(<Pagination.Ellipsis key='ellipsis1' />)
    } else {
      for (let i = 1; i <= 3; i++) {
        items.push(
          <Pagination.Item key={i} active={i === page} onClick={() => setPage(i)}>
            {i}
          </Pagination.Item>
        )
      }
    }

    if (showLastPages) {
      for (let i = totalPages - 2; i <= totalPages; i++) {
        items.push(
          <Pagination.Item key={i} active={i === page} onClick={() => setPage(i)}>
            {i}
          </Pagination.Item>
        )
      }
    }

    if (!showFirstPages && !showLastPages) {
      items.push(
        <Pagination.Item key={page - 1} active={page === page - 1} onClick={() => setPage(page - 1)}>
          {page - 1}
        </Pagination.Item>
      )

      items.push(
        <Pagination.Item key={page} active onClick={() => setPage(page)}>
          {page}
        </Pagination.Item>
      )

      items.push(
        <Pagination.Item key={page + 1} active={page === page + 1} onClick={() => setPage(page + 1)}>
          {page + 1}
        </Pagination.Item>
      )
    }

    if (!showLastPages) {
      items.push(<Pagination.Ellipsis key='ellipsis2' />)

      items.push(
        <Pagination.Item key={totalPages} active={page === totalPages} onClick={() => setPage(totalPages)}>
          {totalPages}
        </Pagination.Item>
      )
    }
  } else {
    for (let i = 1; i <= totalPages; i++) {
      items.push(
        <Pagination.Item key={i} active={i === page} onClick={() => setPage(i)}>
          {i}
        </Pagination.Item>
      )
    }
  }

  return (
    <Row className='mt-3 pagination' ref={paginationRef}>
      <Col xs={12} md={3} className='d-flex align-items-center ' style={{ paddingLeft: "2rem", color: "#333" }}>
        {showTotalCount && (
          <p className='mb-0 ' >{countText} {totalCount}</p>
        )}
      </Col>
      <Col xs={12} md={9} className='d-flex align-items-center justify-content-end'>
        {!dontShowRow && (
          <div className="d-flex align-items-center">
            <Form.Label className='d-none d-sm-block' style={{ marginBottom: '0', marginRight: '15px' }}>
              Rows Per Page:
            </Form.Label>
            <Form.Select
              style={{ maxWidth: '70px', height: '40px', padding: '0, 0.5rem', marginRight: '20px' }}
              value={limit}
              onChange={(event) => {
                setLimit(event.target.value)
                setPage(1)
              }}
            >
              {OPTIONS_ARR.map((o) => (
                <option key={o} value={o}>
                  {o}
                </option>
              ))}
            </Form.Select>
          </div>
        )}

        <Pagination>
          <Pagination.Prev
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          />
          {items}
          <Pagination.Next
            disabled={page >= totalPages}
            onClick={() => setPage(page + 1)}
          />
        </Pagination>
      </Col>
    </Row>
  )
}

export default PaginationComponent
